import { useT } from "@/i18n/provider";
import { cx } from "./cx";

/** A turning ring. Inside buttons and anywhere one thing is loading. */
export function Spinner({ size = 20, className, label }: { size?: number; className?: string; label?: string }) {
  const t = useT();
  return (
    <span role="status" className={cx("inline-flex", className)}>
      <span
        aria-hidden="true"
        style={{ width: size, height: size }}
        className="animate-spin rounded-full border-2 border-current border-r-transparent"
      />
      <span className="sr-only">{label ?? t.loading}</span>
    </span>
  );
}

/** A grey block that pulses where text will be, while a page loads. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <span aria-hidden="true" className={cx("block animate-pulse rounded-control bg-disabled-surface", className)} />
  );
}
